// extracted by mini-css-extract-plugin
export default {"root":"H1_root__G4lSZ","includeBorder":"H1_includeBorder__Lz8o4","inverted":"H1_inverted__SQflp","left":"H1_left__IGR0L","center":"H1_center__o3EV9"};